export default class WaveEffect {
  constructor (dark = [], light = []) {
    this.dark = dark.concat([
      'img.w-100',
      '.service.grey'
    ]);

    this.light = light.concat([
      '.row.member',
      '.btn-primary',
      '.btn-secondary',
      '.service:not(.grey)',
      '.btn-outline-primary'
    ])

    this.init();
  }

  init () {
    this.dark.forEach(el => Waves.attach(el));
    this.light.forEach(el =>  Waves.attach(el, ['waves=light']));
    Waves.init();
  }
}



// WEBPACK FOOTER //
// ./resources/js/modules/waves/index.js